( function( $ ) {

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if ( iOS )
    $( '.section-header' ).addClass( 'is-ios' );

})( jQuery );